export var ROOT_PATH;
export var SUPPLIES_PATH;
export var HISTORY_PATH;
export var METERS_PATH;
export var REPORTS_PATH;
export var SMTP_SERVER_PATH;
export var HARDWARE_PATH;
export var SERVERS_PATH;
export var PRINTERS_PATH;
export var MANAGE_PATH;
export var COST_PATH;
export var USERS_PATH;
export var COMPUTERS_PATH;
export var DOCUMENTS_PATH;
export var USERS_GROUPS_PATH;
export var DB_SETTINGS_PATH;
export var LICENSE_PATH;
export var TASKS_PATH;
export var DB_POLLING_PATH;
export var LOGIN_PATH;
export var PASSWORD_PATH;
export var COMPUTERS_GROUPS_PATH;

ROOT_PATH = "/";
SUPPLIES_PATH = "/supplies";
HISTORY_PATH = "/supplies_history";
METERS_PATH = "/device_meters";
REPORTS_PATH = "/email_reports";
SMTP_SERVER_PATH = "/smtp_server";
HARDWARE_PATH = "/hardware";
SERVERS_PATH = "/servers";
PRINTERS_PATH = "/printers";
MANAGE_PATH = "/manage";
COST_PATH = "/cost";
USERS_PATH = "/users";
USERS_GROUPS_PATH = "/users_groups";
COMPUTERS_PATH = "/computers";
DOCUMENTS_PATH = "/documents";
DB_SETTINGS_PATH = "/db_settings";
DB_POLLING_PATH = "/db_polling";
LICENSE_PATH = "/license";
TASKS_PATH = "/tasks";
LOGIN_PATH = "/login";
PASSWORD_PATH = "/password";
COMPUTERS_GROUPS_PATH = "/comp_groups";


export const RECEIVER_EMAIL = "email";
export const REPORT_PERIOD  = "period";
export const REPORT_URL  = "url";
export const REPORT_ID  = "id";
export const REPORT_FILTER = "filter";
export const REPORT_FILTER_NAME = "name";
export const REPORT_FILTER_VALUE = "value";
export const REPORT_EVENT_NAME = "event_name";
export const REPORT_PRINTER_ID = "printer_id"; 

export const REPORT_PERIOD_EVENT = 7;

export const API_TOKEN = "PrnwatchToken";